import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import mobileMenuReducer from '../reducers/mobileMenuReducer';

const configureStore = (railsProps) => (
  createStore(mobileMenuReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
